"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProductWeight = exports.updatedQuantityBasedOnQuantityUom = exports.getConversionUomObject = void 0;

var common_process_cut_1 = require("@ryerson/common.process-cut");

var common_conversions_1 = require("@ryerson/common.conversions");

var getConversionUomObject = function getConversionUomObject(quantity, qtyUom, priceUom, productDetail) {
  return {
    quantity: quantity.toString(),
    uom: qtyUom,
    pricingUom: priceUom,
    weightPerPiece: Number((productDetail === null || productDetail === void 0 ? void 0 : productDetail.weightPerPiece) || 0),
    weightPerSquareFoot: Number((productDetail === null || productDetail === void 0 ? void 0 : productDetail.weightPerSquareFoot) || 0),
    weightPerFoot: Number((productDetail === null || productDetail === void 0 ? void 0 : productDetail.weightPerFoot) || 0)
  };
};

exports.getConversionUomObject = getConversionUomObject;

var updatedQuantityBasedOnQuantityUom = function updatedQuantityBasedOnQuantityUom(product, quantityUom, displayQuantity) {
  var isRoundDown = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var roundedQuantityBasedOnQtyUom = displayQuantity.toString();

  if (displayQuantity === 0) {
    return displayQuantity;
  }

  if (product && displayQuantity > 0) {
    var conversionQuantityObject = {
      quantity: displayQuantity.toString(),
      uom: quantityUom,
      weightPerPiece: product.weightPerPiece || 0,
      weightPerSquareFoot: product.weightPerSquareFoot || 0,
      weightPerFoot: product.weightPerFoot || 0,
      materialWidth: product.materialWidth || 0,
      materialLengthMin: product.materialLengthMin || 0
    };
    roundedQuantityBasedOnQtyUom = (0, common_conversions_1.calculateNextAvailableQuantity)(conversionQuantityObject);
  }

  var updatedQuantity = Number(roundedQuantityBasedOnQtyUom);

  if (isRoundDown) {
    updatedQuantity = Math.floor(updatedQuantity);
  }

  return updatedQuantity;
};

exports.updatedQuantityBasedOnQuantityUom = updatedQuantityBasedOnQuantityUom;

var defaultProductWeight = function defaultProductWeight(product) {
  var _ref = product || {},
      _ref$category = _ref.category,
      category = _ref$category === void 0 ? "" : _ref$category,
      _ref$form = _ref.form,
      form = _ref$form === void 0 ? "" : _ref$form;

  category = category && category.toLowerCase();
  form = form && form.toLowerCase();

  if (category === common_process_cut_1.Product.CARBON.toLowerCase() && (form === common_process_cut_1.Form.SHEET.toLowerCase() || form === common_process_cut_1.Form.PLATE.toLowerCase())) {
    return 500;
  } else if (form === common_process_cut_1.Form.COIL.toLowerCase() || form === "cutcoil") {
    return 2000;
  }

  return 200;
};

exports.defaultProductWeight = defaultProductWeight;